<template>
    <div v-resize="onResize" class="blog-block">
        <a class="blog-url text-decoration-none" :class="{'cursor-pointer': blogUrl}" :href="blogUrl">
            <main-header :title="$t('blog')" />
        </a>
        <swiper
            v-if="showSwiper"
            :modules="modules"
            :slides-per-view="slidesPerView"
            :space-between="20"
            navigation
            class="pa-4"
            @slide-change="updateLoop"
        >
            <swiper-slide v-for="(item, index) in items" :key="index" :class="{'swiper-slide-ssr': swiperSlideSsr}">
                <blog-item :item="item" @selected="search($event)" />
            </swiper-slide>
        </swiper>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator'
    import BlogItem from '@/components/parts/BlogItem.vue'
    import {searchRequest} from '@/utils/hotels/hotels-blank-states'
    import MainHeader from '~src/components/snippets/mainHeader.src'
    import {SwiperMixin} from '@/components/mixins/SwiperMixin.vue'
    import {Navigation, Pagination} from 'swiper/modules'
    import {Swiper, SwiperSlide} from 'swiper/vue'
    import 'swiper/css'
    import 'swiper/css/navigation'

    @Component({
        components: {
            MainHeader,
            BlogItem,
            Swiper,
            SwiperSlide,
        },
    })
    export class Blog extends SwiperMixin {
        @Prop({required: true}) items

        modules = [Pagination, Navigation]
        swiperSlideSsr = false

        created() {
            this.swiperSlideSsr = !this.$breakpoint.smAndDown
        }

        async search(cityId) {
            await this.$router.push(
                hotelsRuntimeStore.hotelsPageLink({
                    ...searchRequest(),
                    cityId,
                    citizenshipId: authStore.defaultCitizenshipId,
                })
            )
        }

        updateLoop(e) {
            e.loopDestroy()
            e.loopCreate()
        }

        get slidesPerView() {
            return this.$breakpoint.smAndDown ? 1 : this.$breakpoint.mdAndDown ? 4 : 5
        }

        get blogUrl() {
            return cmsStore.homePageSettings.blogUrl ? cmsStore.homePageSettings.blogUrl : 'javascript: void(0);'
        }
    }

    export default Blog
</script>

<style lang="scss" scoped>
    :deep(div.swiper-button-prev),
    :deep(div.swiper-button-next) {
        color: white;
        top: 142px;
    }
    :deep(div.swiper-button-prev) {
        left: 20px;
    }
    :deep(div.swiper-button-next) {
        right: 20px;
    }
    :deep(.blog-url) {
        color: #000;
        cursor: default;
    }
    /*.blog-url:hover {
        color: #6699cc;
    }*/
    :deep(.swiper-slide-ssr) {
        width: 25%;
        margin-right: 20px;
        float: left;
    }
</style>
